/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { TemplatesList, TemplatesListSearchParams } from '../api/alerts/alertsClient.typings';
import { AlertsSettingsAction, AlertsSettingsActionType } from '../actions/alertsSettingsActions';
import { updateItemInArray } from '../../utils/utils';

export interface AlertsSettingsState {
    templatesList: TemplatesList;
    templatesListSearchParams: TemplatesListSearchParams;
    isLoading: boolean;
}

const initialState: AlertsSettingsState = {
    templatesList: {
        count: 0,
        alertsTemplates: [],
    },
    templatesListSearchParams: {
        limit: 10,
        offset: 0,
    },
    isLoading: false,
};

export function alertsSettingsReducer(
    state: AlertsSettingsState = initialState,
    action: AlertsSettingsAction,
): AlertsSettingsState {
    switch (action.type) {
        case AlertsSettingsActionType.OPEN_ALERTS_SETTINGS_PAGE:
            return {
                ...state,
            };

        case AlertsSettingsActionType.CHANGE_ALERTS_TEMPLATES_SEARCH_PARAMS:
            return {
                ...state,
                templatesListSearchParams: action.payload,
            };

        case AlertsSettingsActionType.FETCH_ALERTS_TEMPLATES_SUCCESS:
            return {
                ...state,
                templatesList: action.payload,
                isLoading: false,
            };

        case AlertsSettingsActionType.UPDATE_ALERT_TEMPLATE_SUCCESS:
            const templates = updateItemInArray(state.templatesList.alertsTemplates, action.payload, 'id');

            return {
                ...state,
                templatesList: {
                    ...state.templatesList,
                    alertsTemplates: templates,
                },
                isLoading: false,
            };

        case AlertsSettingsActionType.SET_LOADING:
            return {
                ...state,
                isLoading: true,
            };

        case AlertsSettingsActionType.ALERTS_SETTINGS_PAGE_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case AlertsSettingsActionType.EXIT_ALERTS_SETTINGS_PAGE:
            return {
                ...state,
                isLoading: false,
            };
    }
    return state;
}
